"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coinsToGetFromPyth = exports.coinGeckoPriceFeed = exports.pythPriceFeed = void 0;
// TODO: add more pairs
exports.pythPriceFeed = {
    "SUI/USD": {
        symbol: "Crypto.SUI/USD",
        priceId: "0x23d7315113f5b1d3ba7a83604c44b94d79f4fd69af77f804fc7f920a6dc65744",
        name: "SUI",
    },
    "VSUI/USD": {
        symbol: "Crypto.VSUI/USD",
        priceId: "0x57ff7100a282e4af0c91154679c5dae2e5dcacb93fd467ea9cb7e58afdcfde27",
        name: "VSUI",
    },
    "AFSUI/USD": {
        symbol: "Crypto.AFSUI/USD",
        priceId: "0x17cd845b16e874485b2684f8b8d1517d744105dbb904eec30222717f4bc9ee0d",
        name: "AFSUI",
    },
    "HASUI/USD": {
        symbol: "Crypto.HASUI/USD",
        priceId: "0x6120ffcf96395c70aa77e72dcb900bf9d40dccab228efca59a17b90ce423d5e8",
        name: "HASUI",
    },
    "USDC/USD": {
        symbol: "Crypto.USDC/USD",
        priceId: "0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a",
        name: "USDC",
    },
    "USDT/USD": {
        symbol: "Crypto.USDT/USD",
        priceId: "0x2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b",
        name: "USDT",
    },
    "NAVX/USD": {
        symbol: "Crypto.NAVX/USD",
        priceId: "0x88250f854c019ef4f88a5c073d52a18bb1c6ac437033f5932cd017d24917ab46",
        name: "NAVX",
    },
    "CETUS/USD": {
        symbol: "Crypto.CETUS/USD",
        priceId: "0xe5b274b2611143df055d6e7cd8d93fe1961716bcd4dca1cad87a83bc1e78c1ef",
        name: "CETUS",
    },
    "TURBOS/USD": {
        symbol: "Crypto.TURBOS/USD",
        priceId: "0xf9c2e890443dd995d0baafc08eea3358be1ffb874f93f99c30b3816c460bbac3",
        name: "TURBOS",
    },
    "SCA/USD": {
        name: "SCA",
        priceId: "0x7e17f0ac105abe9214deb9944c30264f5986bf292869c6bd8e8da3ccd92d79bc",
        symbol: "Crypto.SCA/USD",
    },
    "WETH/USD": {
        name: "WETH",
        priceId: "0x9d4294bbcd1174d6f2003ec365831e64cc31d9f6f15a2b85399db8d5000960f6",
        symbol: "Crypto.WETH/USD",
    },
    "APT/USD": {
        name: "APT",
        priceId: "0x03ae4db29ed4ae33d323568895aa00337e658e348b37509f5372ae51f0af00d5",
        symbol: "Crypto.APT/USD",
    },
    "SOL/USD": {
        name: "SOL",
        priceId: "0xef0d8b6fda2ceba41da15d4095d1da392a0d2f8ed0c6c7bc0f4cfac8c280b56d",
        symbol: "Crypto.SOL/USD",
    },
    "WSOL/USD": {
        name: "WSOL",
        priceId: "0xef0d8b6fda2ceba41da15d4095d1da392a0d2f8ed0c6c7bc0f4cfac8c280b56d",
        symbol: "Crypto.SOL/USD",
    },
    "SLP/USD": {
        name: "SLP",
        priceId: "0xfba17701be318087db58d9797d5f1e89dcf5b95773ae2227c8a8eb4cf1d4e554",
        symbol: "Crypto.SLP/USD",
    },
    "WBTC/USD": {
        name: "WBTC",
        priceId: "0xc9d8b075a5c69303365ae23633d4e085199bf5c520a3b90fed1322a0342ffc33",
        symbol: "Crypto.WBTC/USD",
    },
    "CELO/USD": {
        name: "CELO",
        priceId: "0x7d669ddcdd23d9ef1fa9a9cc022ba055ec900e91c4cb960f3c20429d4447a411",
        symbol: "Crypto.CELO/USD",
    },
    //TODO --> to change priceId when its listed
    "ALPHA/USD": {
        symbol: "Crypto.ALPHA/USD",
        priceId: "0x2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b",
        name: "ALPHA",
    },
    //TODO --> to change priceId when its listed
    "USDY/USD": {
        symbol: "Crypto.USDY/USD",
        priceId: "0xe393449f6aff8a4b6d3e1165a7c9ebec103685f3b41e60db4277b5b6d10e7326",
        name: "USDY",
    },
    "BUCK/USD": {
        symbol: "Crypto.BUCK/USD",
        priceId: "0xfdf28a46570252b25fd31cb257973f865afc5ca2f320439e45d95e0394bc7382",
        name: "BUCK",
    },
    "WUSDC/USD": {
        symbol: "Crypto.USDC/USD",
        priceId: "0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a",
        name: "WUSDC",
    },
    "FUD/USD": {
        symbol: "Crypto.FUD/USD",
        priceId: "0x6a4090703da959247727f2b490eb21aea95c8684ecfac675f432008830890c75",
        name: "FUD",
    },
    "DEEP/USD": {
        symbol: "Crypto.DEEP/USD",
        priceId: "0x29bdd5248234e33bd93d3b81100b5fa32eaa5997843847e2c2cb16d7c6d9f7ff",
        name: "DEEP",
    },
    "ETH/USD": {
        symbol: "Crypto.ETH/USD",
        priceId: "0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace",
        name: "ETH",
    },
    "AUSD/USD": {
        symbol: "Crypto.AUSD/USD",
        priceId: "0xd9912df360b5b7f21a122f15bdd5e27f62ce5e72bd316c291f7c86620e07fb2a",
        name: "AUSD",
    },
    "NS/USD": {
        symbol: "Crypto.NS/USD",
        priceId: "0xbb5ff26e47a3a6cc7ec2fce1db996c2a145300edc5acaabe43bf9ff7c5dd5d32",
        name: "NS",
    },
    "BLUE/USD": {
        symbol: "Crypto.BLUE/USD",
        priceId: "0x04cfeb7b143eb9c48e9b074125c1a3447b85f59c31164dc20c1beaa6f21f2b6b",
        name: "BLUE",
    },
    "SEND/USD": {
        symbol: "Crypto.SEND/USD",
        priceId: "0x7d19b607c945f7edf3a444289c86f7b58dcd8b18df82deadf925074807c99b59",
        name: "SEND",
    },
    "STSUI/USD": {
        symbol: "Crypto.STSUI/USD",
        priceId: "",
        name: "STSUI",
    },
    "SUIUSDT/USD": {
        symbol: "Crypto.USDT/USD",
        priceId: "0x2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b",
        name: "USDT",
    },
    "SUIBTC/USD": {
        name: "WBTC",
        priceId: "0xc9d8b075a5c69303365ae23633d4e085199bf5c520a3b90fed1322a0342ffc33",
        symbol: "Crypto.WBTC/USD",
    },
    "LBTC/USD": {
        name: "WBTC",
        priceId: "0xc9d8b075a5c69303365ae23633d4e085199bf5c520a3b90fed1322a0342ffc33",
        symbol: "Crypto.WBTC/USD",
    },
    "DMC/USD": {
        name: "DMC",
        priceId: "0x8abfa63ae82ca2fbc271861375e497166d8792580fb7c2ffcf014d2a131433f0",
        symbol: "Crypto.DMC/USD",
    },
    "IKA/USD": {
        name: "IKA",
        priceId: "0x2b529621fa6e2c8429f623ba705572aa64175d7768365ef829df6a12c9f365f4",
        symbol: "Crypto.IKA/USD",
    },
    "TBTC/USD": {
        name: "TBTC",
        priceId: "0x56a3121958b01f99fdc4e1fd01e81050602c7ace3a571918bb55c6a96657cca9",
        symbol: "Crypto.TBTC/USD",
    },
    "XBTC/USD": {
        name: "XBTC",
        priceId: "0xae8f269ed9c4bed616c99a98cf6dfe562bd3202e7f91821a471ff854713851b4",
        symbol: "Crypto.XBTC/USD",
    },
    "ALKIMI/USD": {
        name: "ALKIMI",
        priceId: "0x1b2deae525b02c52de4a411c4f37139931215d7cc754e57dd6c84387336ccc74",
        symbol: "Crypto.ALKIMI/USD",
    },
    "XAUM/USD": {
        name: "XAUM",
        priceId: "0xd7db067954e28f51a96fd50c6d51775094025ced2d60af61ec9803e553471c88",
        symbol: "Crypto.XAUM/USD",
    },
    "UP/USD": {
        name: "UP",
        priceId: "0xc591a547856b091560b120ee14b165a84ca58eca23b2ab635df641340bde1f10",
        symbol: "Crypto.UP/USD",
    },
    "ESUI/USD": {
        name: "ESUI",
        priceId: "0x2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b", //to be updated with actual priceId
        symbol: "Crypto.ESUI/USD",
    },
    "EBTC/USD": {
        name: "EBTC",
        priceId: "0x2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b", //to be updated with actual priceId
        symbol: "Crypto.EBTC/USD",
    },
    "EGUSDC/USD": {
        name: "EGUSDC",
        priceId: "0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a",
        symbol: "Crypto.EGUSDC/USD",
    },
    "ETHIRD/USD": {
        name: "ETHIRD",
        priceId: "0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a", //to be updated with actual priceId, currently using USDC priceId
        symbol: "Crypto.ETHIRD/USD",
    },
    "EXBTC/USD": {
        name: "EXBTC",
        priceId: "0x56a3121958b01f99fdc4e1fd01e81050602c7ace3a571918bb55c6a96657cca9", //to be updated with actual priceId, currently using TBTC priceId
        symbol: "Crypto.EXBTC/USD",
    },
    "SDEUSD/USD": {
        name: "SDEUSD",
        priceId: "0x0a03c915d98ab4084795d283e20f08d7130acd826bca180754b120bfc202f2fb",
        symbol: "Crypto.SDEUSD/USD",
    },
    "EWAL/USD": {
        name: "EWAL",
        priceId: "0xeba0732395fae9dec4bae12e52760b35fc1c5671e2da8b449c9af4efe5d54341",
        symbol: "Crypto.EWAL/USD",
    },
};
exports.coinGeckoPriceFeed = {
    "ALPHA/USD": {
        coinId: "alpha-fi",
        name: "ALPHA",
    },
    "SUI/USD": {
        coinId: "sui",
        name: "SUI",
    },
    "STSUI/USD": {
        coinId: "alphafi-staked-sui",
        name: "STSUI",
    },
    "VSUI/USD": {
        coinId: "volo-staked-sui",
        name: "VSUI",
    },
    "AFSUI/USD": {
        coinId: "aftermath-staked-sui",
        name: "AFSUI",
    },
    "HASUI/USD": {
        coinId: "haedal-staked-sui",
        name: "HASUI",
    },
    "USDC/USD": {
        coinId: "usd-coin",
        name: "USDC",
    },
    "USDT/USD": {
        coinId: "tether-usd-wormhole-from-ethereum",
        name: "USDT",
    },
    "NAVX/USD": {
        coinId: "navi",
        name: "NAVX",
    },
    "CETUS/USD": {
        coinId: "cetus-protocol",
        name: "CETUS",
    },
    "TURBOS/USD": {
        coinId: "turbos-finance",
        name: "TURBOS",
    },
    "SCA/USD": {
        name: "SCA",
        coinId: "scallop-2",
    },
    "WETH/USD": {
        name: "WETH",
        coinId: "ethereum-wormhole",
    },
    "APT/USD": {
        name: "APT",
        coinId: "aptos",
    },
    "SOL/USD": {
        name: "SOL",
        coinId: "solana",
    },
    "WSOL/USD": {
        name: "WSOL",
        coinId: "solana",
    },
    "SLP/USD": {
        name: "SLP",
        coinId: "slp",
    },
    "WBTC/USD": {
        name: "WBTC",
        coinId: "wrapped-btc-wormhole",
    },
    "CELO/USD": {
        name: "CELO",
        coinId: "celo",
    },
    "USDY/USD": {
        coinId: "ondo-us-dollar-yield",
        name: "USDY",
    },
    "BUCK/USD": {
        coinId: "bucket-protocol-buck-stablecoin",
        name: "BUCK",
    },
    "WUSDC/USD": {
        coinId: "usd-coin-wormhole-from-ethereum",
        name: "WUSDC",
    },
    "FUD/USD": {
        coinId: "fud-the-pug",
        name: "FUD",
    },
    "BLUB/USD": {
        coinId: "blub",
        name: "BLUB",
    },
    "DEEP/USD": {
        coinId: "deep",
        name: "DEEP",
    },
    "ETH/USD": {
        name: "ETH",
        coinId: "ethereum",
    },
    "AUSD/USD": {
        name: "AUSD",
        coinId: "agora-dollar",
    },
    "NS/USD": {
        name: "NS",
        coinId: "suins-token",
    },
    "BLUE/USD": {
        name: "BLUE",
        coinId: "bluefin",
    },
    "SEND/USD": {
        name: "SEND",
        coinId: "suilend",
    },
    "SUIUSDT/USD": {
        coinId: "tether-usd-wormhole-from-ethereum",
        name: "USDT",
    },
    "MUSD/USD": {
        coinId: "tether-usd-wormhole-from-ethereum",
        name: "USDT",
    },
    "SUIBTC/USD": {
        name: "WBTC",
        coinId: "wrapped-btc-wormhole",
    },
    "LBTC/USD": {
        name: "LBTC",
        coinId: "lombard-staked-btc",
    },
    "WAL/USD": {
        name: "WAL",
        coinId: "walrus-2",
    },
    "DMC/USD": {
        coinId: "delorean",
        name: "DMC",
    },
    "TBTC/USD": {
        name: "TBTC",
        coinId: "tbtc",
    },
    "IKA/USD": {
        name: "IKA",
        coinId: "ika",
    },
    "XBTC/USD": {
        name: "XBTC",
        coinId: "okx-wrapped-btc",
    },
    "ALKIMI/USD": {
        name: "ALKIMI",
        coinId: "alkimi-2",
    },
    "XAUM/USD": {
        name: "XAUM",
        coinId: "matrixdock-gold",
    },
    "UP/USD": {
        name: "UP",
        coinId: "doubleup",
    },
    "ESUI/USD": {
        name: "ESUI",
        coinId: "sui", //to be updated with actual coinId
    },
    "EBTC/USD": {
        name: "EBTC",
        coinId: "wrapped-btc-wormhole", //to be updated with actual coinId
    },
    "EGUSDC/USD": {
        name: "EGUSDC",
        coinId: "usd-coin",
    },
    "ETHIRD/USD": {
        name: "ETHIRD",
        coinId: "usd-coin",
    },
    "EXBTC/USD": {
        name: "EXBTC",
        coinId: "wrapped-btc-wormhole",
    },
    "SDEUSD/USD": {
        name: "SDEUSD",
        coinId: "elixir-staked-deusd",
    },
    "EWAL/USD": {
        name: "EWAL",
        coinId: "walrus-2",
    },
};
exports.coinsToGetFromPyth = [
    "SUI/USD",
    "USDC/USD",
    "USDT/USD",
    "HASUI/USD",
    "CETUS/USD",
    "VSUI/USD",
    "NAVX/USD",
    "SCA/USD",
    "AFSUI/USD",
    "WETH/USD",
    "WBTC/USD",
    "TURBOS/USD",
    "CELO/USD",
    "SLP/USD",
    "SOL/USD",
    "APT/USD",
    "BUCK/USD",
    "WSOL/USD",
    "WUSDC/USD",
    "ALPHA/USD",
    "FUD/USD",
    "BLUB/USD",
    "ETH/USD",
    "DEEP/USD",
    "AUSD/USD",
    "USDY/USD",
    "NS/USD",
    "BLUE/USD",
    "SEND/USD",
    "STSUI/USD",
    "SUIUSDT/USD",
    "MUSD/USD",
    "SUIBTC/USD",
    "LBTC/USD",
    "DMC/USD",
    "IKA/USD",
    "TBTC/USD",
    "XBTC/USD",
    "ALKIMI/USD",
    "XAUM/USD",
    "UP/USD",
    "ESUI/USD",
    "EBTC/USD",
    "EGUSDC/USD",
    "ETHIRD/USD",
    "EXBTC/USD",
    "SDEUSD/USD",
    "EWAL/USD",
];
//# sourceMappingURL=constants.js.map